import { ComponentIds, InSceneComponent, SelectedComponent } from '@inter-ikea-core/core';
import { SomethingIsDraggedComponent } from '@inter-ikea-core/core';
import { CoreApi, PlannerEcsMultiSystem } from '../..';
import StabilityComponent from '../components/StabilityComponent';

type SubscribedComponent = SelectedComponent | SomethingIsDraggedComponent | InSceneComponent;

/**
 * This system is enabled by the StabilityValidationSheet if user continues with their design after that stability
 * shelves has been added. The stability shelves are then kepth outlined and this system is responsible to remove the
 * outline on user interaction in scene
 */
export class StabilityOutlineSystem extends PlannerEcsMultiSystem<SubscribedComponent> {
  constructor(coreApi: CoreApi) {
    super(coreApi, 'StabilityOutlineSystem', [
      ComponentIds.SELECTED_COMPONENT_ID,
      ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID,
      ComponentIds.IN_SCENE_COMPONENT_ID
    ]);
    this.disable();
  }

  onAdd(): void {
    if (this.isEnabled) {
      const stabilityShelves = this.coreApi.entities.getByComponent(StabilityComponent.id);
      stabilityShelves.forEach(shelf => {
        shelf.removeComponent(StabilityComponent.id);
        if (!shelf.hasComponent(ComponentIds.SELECTED_COMPONENT_ID)) {
          shelf.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        }
      });
      this.disable();
    }
  }

  onUpdate(): void {}

  onRemove(): void {}
}
